module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-4-02ff6fb286904cae5a2bec9e5bd93e08.png";